import moment from 'moment'

export default {
    numberWithSpaces: (value) => {
        if(value) {
            return value.toLocaleString('sv-SE')
        }
    },
    formatDate: (value) => {
      if (value) {
        moment.locale('sv');
        return moment(String(value)).format('YYYY-MM-DD HH:mm')
      }
    },
    formatDateWithoutTime: (value) => {
      if (value) {
        moment.locale('sv');
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    formatTimeWithoutDate: (value) => {
        if (value) {
            moment.locale('sv');
            return moment(String(value)).format('HH:mm')
        }
    },
    formatDateWithMonth: (value) => {
        if (value) {
            moment.locale('sv');
            return moment(String(value)).format('D MMM YYYY')
        }
    },
    truncate: function(string, n, useWordBoundary) {
        if (string.length <= n) { return string; }
        let subString = string.substr(0, n-1);
        return (useWordBoundary
           ? subString.substr(0, subString.lastIndexOf(' '))
           : subString) + "…";
    },
    stripHTML: function(string) {
        return string.replace(/(<([^>]+)>)/ig,"");
    },
    addProtocol: (link) => {
        let newLink = link;
        const protocolPattern = /^(http|https):\/\//i;
        const wwwPattern = /^www/g;

        if( !link.match(protocolPattern) && !link.match(wwwPattern) ) {
            newLink = 'http://www.' + link;
        } else if ( !link.match(protocolPattern) && link.match(wwwPattern) ) {
            newLink = 'http://' + link;
        };

        return newLink;
    },
    stripAllSpecialChar: (value) => {
        const pattern = /([^A-Zåäö ])/gmi;

        return value.replace(pattern, "");
    },
    stripInitialSpecialChar: (value) => {
        const pattern = /([^A-Zåäö &-])/gmi;

        return value.replace(pattern, "");
    }
}



// WEBPACK FOOTER //
// ./src/filters/index.js